export default "__VITE_ASSET__DT3mvFf4__"